const { Modal } = require("bootstrap");

$(function (readyEvent) {
    if (/(\?|\&)formSent=1/.test(window.location.search)) {
        console.log(window.location);
        window.history.pushState(
            "",
            "",
            `${window.location.origin}${window.location.pathname}`
        );

        const $modal = $(`<div class="modal" tabindex="-1">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="text-center">Vielen Dank für Ihre Bestellung</p>
                                    </div>
                                </div>
                            </div>
                        </div>`);

        $modal.appendTo(document.body);
        new Modal($modal[0]).show();
    }
});
